@if (showSearch || showFilter) {
  <div class="search-container item-picker-mid-size">
    <ng-content select="[payment-table-search]"></ng-content>
    @if (showFilter) {
      <mat-form-field
        floatLabel="always"
        class="mat-select-form-field"
        appearance="outline"
      >
        <mat-select
          panelClass="item-picker-mid-size"
          (selectionChange)="itemPickerSelected.emit($event.value)"
          [required]="false"
          [(value)]="selectedFilterValue"
          disableOptionCentering
        >
          @for (item of filterItems; track item) {
            <mat-option [value]="item">
              {{ item.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
}
<div class="scrollable-content app-lineup-table">
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef>Transaction Date</th>
      <td mat-cell *matCellDef="let element">
        {{ element.createdOn | date: 'mediumDate' : 'utc' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="invoiceStatus">
      <th mat-header-cell *matHeaderCellDef>Payment Status</th>
      <td mat-cell *matCellDef="let element">
        <div class="invoice-status">
          <mat-icon [ngClass]="getInvoiceStatusIcon(element)">{{
            getInvoiceStatusIcon(element)
          }}</mat-icon>
          {{ invoiceStatus[element.invoiceStatus] }}
        </div>
        @if (invoiceStatus[element.invoiceStatus] === invoiceStatus.Open) {
          <div class="invoice-status">
            @if (element.dueDate) {
              <div>Due: {{ element.dueDate | date: 'mediumDate' }}</div>
            }
          </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef>Amount</th>
      <td mat-cell *matCellDef="let element">${{ element.amount }} USD</td>
    </ng-container>

    <ng-container matColumnDef="orderNumber">
      <th mat-header-cell *matHeaderCellDef>Order Number</th>
      <td mat-cell *matCellDef="let element">{{ element.orderNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="completionDate">
      <th mat-header-cell *matHeaderCellDef>Completion Date</th>
      <td mat-cell *matCellDef="let element">
        {{ element.completionDate | date: 'mediumDate' : 'utc' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="paymentType">
      <th mat-header-cell *matHeaderCellDef>Payment Type</th>
      <td mat-cell *matCellDef="let element">
        @if (element.paymentDisplayHighlight) {
          <div class="invoice_institution">
            {{ element.paymentDisplayHighlight }}
          </div>
        }
        <div>
          {{ element.paymentTypeDisplay }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="actionButtons">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="action-buttons">
          @if (invoiceStatus[element.invoiceStatus] === invoiceStatus.Paid) {
            <button
              class="outlined-button"
              mat-icon-button
              matTooltip="Document actions"
              aria-label="Document actions"
              matTooltipShowDelay="500"
              (click)="openInvoicePayment.emit(element)"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          }
          @if (
            element.invoiceNumber &&
            invoiceStatus[element.invoiceStatus] === invoiceStatus.Open
          ) {
            <button
              class="outlined-button"
              mat-icon-button
              matTooltip="Copy invoice link"
              aria-label="Copy invoice link"
              matTooltipShowDelay="500"
              [cdkCopyToClipboard]="element.paymentLink"
              (cdkCopyToClipboardCopied)="copyInvoiceLink.emit()"
            >
              <mat-icon>link</mat-icon>
            </button>
          }
          @if (
            invoiceStatus[element.invoiceStatus] === invoiceStatus.Open &&
            element.paymentType === 'Check' &&
            !isPortal
          ) {
            <button
              class="outlined-button"
              mat-icon-button
              matTooltip="Payment by check"
              aria-label="Payment by check"
              matTooltipShowDelay="500"
              (click)="addCheckReceived.emit(element)"
            >
              <mat-icon>attach_money</mat-icon>
            </button>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
